import React, { useState } from "react";
import { Modal, Form, Alert } from "react-bootstrap";
import { Button } from "./Controls/Button";
interface InviteModalProps {
  show: boolean;
  parkerName: string;
  defaultHoldPeriod: number;
  onConfirm: (holdPeriodHours: number) => void;
  onCancel: () => void;
}

const InviteParkerModal: React.FC<InviteModalProps> = ({
  show,
  parkerName,
  defaultHoldPeriod,
  onConfirm,
  onCancel,
}) => {
  const [holdPeriod, setHoldPeriod] = useState<number>(defaultHoldPeriod);

  return (
    <Modal centered show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Invite {parkerName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Alert variant="info" style={{fontSize:".9rem"}} className="mt-2 alert-light-bg">
            
              <b>Below you can specify the amount of time the parker will have to complete their purchase. </b> They will be moved back to the waitlist once expired.
             
            </Alert>
            <Form.Label>Hold Period (hours)</Form.Label>
            <Form.Control
              type="number"
              value={holdPeriod}
              min={1}
              max={168}
              onChange={(e) => setHoldPeriod(parseInt(e.target.value))}
            />
            <Form.Text muted>
                Default is {defaultHoldPeriod} hours. Max 168 hours (7 days).<br /><br />
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className="btn-main"
          disabled={holdPeriod < 1 || holdPeriod > 168}
          onClick={() => onConfirm(holdPeriod)}
        >
          Send Invite
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InviteParkerModal;
